<section id="pageCover" class="row">
    <img src="../../../assets/images/contactCover.png" alt="" class="pageCover">
    <!--<div class="row pageTitle">Projects</div>-->
    <div class="row pageBreadcrumbs">
        <!--<ol class="breadcrumb">
            <li><a href="index.html">home</a></li>
            <li class="active">Projects</li>
        </ol>-->
    </div>
</section>

<section id="blogs" class="row">
    <div class="container">
        <div class="row">
            <div class="col-sm-4 blog">
                <div class="row m0 blogInner">
                    <div class="row m0 blogDateTime">
                        <i class="fa fa-calendar"></i> 18 November 2014, 11:50 AM
                    </div>
                    <div class="row m0 featureImg">
                        <a routerLink="/article">
                            <img src="../../../assets/images/blog/blog1.png" alt="Faceted Search Has Landed" class="img-responsive">
                        </a>
                    </div>
                    <div class="row m0 postExcerpts">
                        <div class="row m0 postExcerptInner">
                            <a routerLink="/article" class="postTitle row m0"><h4>Faceted Search Has Landed</h4></a>
                            <p>This year in our 2014 roadmap one of our goals was to improve financial tooling for authors. A big part of that is the withdrawal cycle.</p>
                            <a routerLink="/article" class="readMore">read more</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-4 blog">
                <div class="row m0 blogInner">
                    <div class="row m0 blogDateTime">
                        <i class="fa fa-calendar"></i> 16 November 2014, 12:20 AM
                    </div>
                    <div class="row m0 featureImg">
                        <a routerLink="/article">
                            <img src="../../../assets/images/blog/blog2.png" alt="Faceted Search Has Landed" class="img-responsive">
                        </a>
                    </div>
                    <div class="row m0 postExcerpts">
                        <div class="row m0 postExcerptInner">
                            <a routerLink="/article" class="postTitle row m0"><h4>Vat and Global Marketplace</h4></a>
                            <p>This year in our 2014 roadmap one of our goals was to improve financial tooling for authors. A big part of that is the withdrawal cycle.</p>
                            <a routerLink="/article" class="readMore">read more</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-4 blog">
                <div class="row m0 blogInner">
                    <div class="row m0 blogDateTime">
                        <i class="fa fa-calendar"></i> 14 November 2014, 10:50 AM
                    </div>
                    <div class="row m0 featureImg">
                        <a routerLink="/article">
                            <img src="../../../assets/images/blog/blog3.png" alt="Faceted Search Has Landed" class="img-responsive">
                        </a>
                    </div>
                    <div class="row m0 postExcerpts">
                        <div class="row m0 postExcerptInner">
                            <a routerLink="/article" class="postTitle row m0"><h4>Default withdrawal option</h4></a>
                            <p>This year in our 2014 roadmap one of our goals was to improve financial tooling for authors. A big part of that is the withdrawal cycle.</p>
                            <a routerLink="/article" class="readMore">read more</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-4 blog">
                <div class="row m0 blogInner">
                    <div class="row m0 blogDateTime">
                        <i class="fa fa-calendar"></i> 18 November 2014, 11:50 AM
                    </div>
                    <div class="row m0 featureImg">
                        <a routerLink="/article">
                            <img src="../../../assets/images/blog/blog1.png" alt="Faceted Search Has Landed" class="img-responsive">
                        </a>
                    </div>
                    <div class="row m0 postExcerpts">
                        <div class="row m0 postExcerptInner">
                            <a routerLink="/article" class="postTitle row m0"><h4>Faceted Search Has Landed</h4></a>
                            <p>This year in our 2014 roadmap one of our goals was to improve financial tooling for authors. A big part of that is the withdrawal cycle.</p>
                            <a routerLink="/article" class="readMore">read more</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-4 blog">
                <div class="row m0 blogInner">
                    <div class="row m0 blogDateTime">
                        <i class="fa fa-calendar"></i> 16 November 2014, 12:20 AM
                    </div>
                    <div class="row m0 featureImg">
                        <a routerLink="/article">
                            <img src="../../../assets/images/blog/blog2.png" alt="Faceted Search Has Landed" class="img-responsive">
                        </a>
                    </div>
                    <div class="row m0 postExcerpts">
                        <div class="row m0 postExcerptInner">
                            <a routerLink="/article" class="postTitle row m0"><h4>Vat and Global Marketplace</h4></a>
                            <p>This year in our 2014 roadmap one of our goals was to improve financial tooling for authors. A big part of that is the withdrawal cycle.</p>
                            <a routerLink="/article" class="readMore">read more</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-4 blog">
                <div class="row m0 blogInner">
                    <div class="row m0 blogDateTime">
                        <i class="fa fa-calendar"></i> 14 November 2014, 10:50 AM
                    </div>
                    <div class="row m0 featureImg">
                        <a routerLink="/article">
                            <img src="../../../assets/images/blog/blog3.png" alt="Faceted Search Has Landed" class="img-responsive">
                        </a>
                    </div>
                    <div class="row m0 postExcerpts">
                        <div class="row m0 postExcerptInner">
                            <a routerLink="/article" class="postTitle row m0"><h4>Default withdrawal option</h4></a>
                            <p>This year in our 2014 roadmap one of our goals was to improve financial tooling for authors. A big part of that is the withdrawal cycle.</p>
                            <a routerLink="/article" class="readMore">read more</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row paginationRow m0">
            <div class="paginationInner m0 row">
                <ul class="pagination fleft">
                    <li class="active"><a href="#">1</a></li>
                    <li><a href="#">2</a></li>
                    <li><a href="#">3</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>